import { render, staticRenderFns } from "./OliveOilsForm.vue?vue&type=template&id=91944390&scoped=true"
import script from "./OliveOilsForm.vue?vue&type=script&lang=js"
export * from "./OliveOilsForm.vue?vue&type=script&lang=js"
import style0 from "./OliveOilsForm.vue?vue&type=style&index=0&id=91944390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91944390",
  null
  
)

export default component.exports